import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent implements OnInit {
  constructor(private matDialog: MatDialog) {}

  ngOnInit(): void {}

  showLoader() {
    const dialog = this.matDialog
      .open(LoaderComponent, {
        width: '240px',
        height: '240px',
        autoFocus: true,
        panelClass: 'load',
        disableClose: true,
      })
      .afterClosed();
  }
}
